import { render, staticRenderFns } from "./arrange-camp.vue?vue&type=template&id=74deed2a&"
import script from "./arrange-camp.vue?vue&type=script&lang=js&"
export * from "./arrange-camp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports